
import { QuickModeConfig, QuickModePreferences, ModeState } from '../types/mode.types';

export const DEFAULT_QUICK_CONFIG: QuickModeConfig = {
  showVocalSelector: true,
  showKeyTempo: false,
  defaultPreset: null,
  autoExpandTemplates: true,
};

export const DEFAULT_PREFERENCES: QuickModePreferences = {
  rememberLastPreset: true,
  autoExpandTemplates: true,
  showCreditsInQuick: true,
};

export const createInitialModeState = (): ModeState => ({
  currentMode: 'quick',
  quickModeConfig: DEFAULT_QUICK_CONFIG,
  lastAdvancedTab: 'studio',
  transitionTimestamp: Date.now(),
});

export interface TabDefinition {
  id: string;
  label: string;
  icon: string;
  quickModeVisible: boolean;
  requiresAdvanced: boolean;
  group?: string;
  adminOnly?: boolean;
}

export const TAB_DEFINITIONS: TabDefinition[] = [
  // Build — the composition pipeline: seed → story → sound → generate
  { id: 'riffwriter',  label: 'RiffWriter', icon: 'Guitar',       quickModeVisible: false, requiresAdvanced: true,  group: 'Build' },
  { id: 'narrative',   label: 'Narrative',  icon: 'BookOpen',     quickModeVisible: false, requiresAdvanced: true,  group: 'Build' },
  { id: 'vocals',      label: 'Vocals',     icon: 'Mic2',         quickModeVisible: false, requiresAdvanced: true,  group: 'Build' },
  { id: 'production',  label: 'Production', icon: 'Sliders',      quickModeVisible: false, requiresAdvanced: true,  group: 'Build' },
  { id: 'axelab',      label: 'Axe Lab',    icon: 'Axe',          quickModeVisible: false, requiresAdvanced: true,  group: 'Build' },
  { id: 'studio',      label: 'Studio',     icon: 'LayoutGrid',   quickModeVisible: true,  requiresAdvanced: false, group: 'Build' },
  // Create — standalone creative modes
  { id: 'album',       label: 'Album',      icon: 'ListMusic',    quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  { id: 'live',        label: 'Live',        icon: 'Radio',        quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  { id: 'image',       label: 'Art',         icon: 'Sparkles',     quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  { id: 'studio_team', label: 'Studio Team',icon: 'Users',        quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  { id: 'roulette',    label: 'Roulette',    icon: 'Dices',        quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  { id: 'simplemode',  label: 'Simple',      icon: 'WandSparkles', quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  { id: 'studioroulette', label: 'Studio Roulette', icon: 'Dice5',  quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  { id: 'speech',      label: 'Speech',      icon: 'Mic',          quickModeVisible: false, requiresAdvanced: true,  group: 'Create' },
  // Forge — post-generation processing: review → MIDI → master
  { id: 'critic',      label: 'Critic',     icon: 'Star',         quickModeVisible: false, requiresAdvanced: true,  group: 'Forge' },
  { id: 'midiforge',   label: 'MIDI',       icon: 'Piano',        quickModeVisible: false, requiresAdvanced: true,  group: 'Forge' },
  { id: 'masterforge', label: 'Master',     icon: 'Disc3',        quickModeVisible: false, requiresAdvanced: true,  group: 'Forge' },
  // Library — data management and extensions
  { id: 'hh_hist',     label: 'Vault',      icon: 'FileText',     quickModeVisible: false, requiresAdvanced: true,  group: 'Library' },
  { id: 'manual_entry',label: 'Manual',     icon: 'PenLine',      quickModeVisible: false, requiresAdvanced: true,  group: 'Library' },
  { id: 'suno_hist',   label: 'Sync',       icon: 'History',      quickModeVisible: false, requiresAdvanced: true,  group: 'Library' },
  { id: 'sessions',    label: 'Sessions',   icon: 'BarChart3',    quickModeVisible: false, requiresAdvanced: true,  group: 'Library' },
  { id: 'analytics',   label: 'Analytics',  icon: 'TrendingUp',   quickModeVisible: false, requiresAdvanced: true,  group: 'Library', adminOnly: true },
  { id: 'suite',       label: 'Suite',      icon: 'Grid3x3',      quickModeVisible: false, requiresAdvanced: true,  group: 'Library' },
  // Output (no group — special position)
  { id: 'output',      label: 'Output',     icon: 'CheckCircle2', quickModeVisible: true,  requiresAdvanced: false },
];

export const QUICK_MODE_TABS = TAB_DEFINITIONS.filter(t => t.quickModeVisible);
export const ADVANCED_MODE_TABS = TAB_DEFINITIONS;
export const MODE_STORAGE_KEY = 'hookhouse_mode_system';
